import { ctaData } from '../../templates/ctaData'

export const getCurrentCTA = cta => {
  let currentCTA
  if (cta && typeof cta !== 'undefined') {
    ctaData.forEach(data => {
      if (cta.includes(data.tag)) {
        currentCTA = data
      }
    })
  }

  if (!currentCTA || typeof currentCTA === 'undefined') {
    currentCTA = ctaData[0]
  }

  return currentCTA
}
